import {SearchFilter} from '../../shared/components/advanced-searchbox/advanced-searchbox.component';
import * as CollectionActions from '../actions/collection.actions';
import {SortDirection, SortField, SortOrder} from '../../shared/models/magento-search-filter';
import {createReducer, on} from '@ngrx/store';

export interface State {
    ids: number[];
    isLoading: boolean;
    currentPage: number;
    pageSize: number;
    searchFilters: SearchFilter[];
    sortOrders: SortOrder[];
    totalProductCount: number;
}

const initialState: State = {
    ids: [],
    isLoading: false,
    currentPage: 0,
    pageSize: 24,
    searchFilters: [],
    sortOrders: [
        {
            field: SortField.SKU,
            direction: SortDirection.ASC
        }
    ],
    totalProductCount: 0,
};

export const reducer = createReducer(
    initialState,
    on(CollectionActions.load, (state, action) => {
        return {
            ...initialState,
            isLoading: true,
            searchFilters: action.command.searchFilters || initialState.searchFilters,
            sortOrders: action.command.sortOrders || initialState.sortOrders
        };
    }),
    on(CollectionActions.add, state => ({...state, isLoading: true})),
    on(CollectionActions.loadSuccess, (state, action) => {
        return {
            ...state,
            isLoading: false,
            ids: [...action.products.map(p => p.id)],
            totalProductCount: action.totalProductCount,
            currentPage: 1,
        };
    }),
    on(CollectionActions.addSuccess, (state, action) => {
        return {
            ...state,
            isLoading: false,
            ids: [...state.ids, ...action.products.map(p => p.id)],
            totalProductCount: action.totalProductCount,
            currentPage: state.currentPage + 1,
        };
    }),
    on(CollectionActions.loadFailure, CollectionActions.addFailure, state => ({...state, isLoading: false}))
);

export const getIsLoading = (state: State) => state.isLoading;
export const getIds = (state: State) => state.ids;
export const getCurrentPage = (state: State) => state.currentPage;
export const getPageSize = (state: State) => state.pageSize;
export const getSearchFilters = (state: State) => state.searchFilters;
export const getSortOrders = (state: State) => state.sortOrders;
export const getTotalProductCount = (state: State) => state.totalProductCount;
